module.exports = __webpack_public_path__ + "img/ic_16_drilldown_white.4ae27f3a.svg";